<template>
  <b-card>
    <transition
      name="fade"
      mode="out-in"
    >
      <certifications-terms-edit-form
        v-if="certificationData"
        mode="edit"
        :certification-data="certificationData"
        :loading="loading"
        :send-information-email.sync="sendInformationEmail"
        @submit="submit"
      />
      <div
        v-else
        class="text-center"
      >
        <b-spinner style="width: 4em; height: 4em;" />
      </div>
    </transition>
  </b-card>
</template>

<script>
import { BCard, BSpinner } from 'bootstrap-vue'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import buildCertificationPayload from '@/helpers/buildCertificationPayload'
import { mapCertificationApiToFormData } from '@/helpers/certification/certificationTermsEditLogic'
import resolveCertificationTermsApiError from '@/helpers/certification/resolveCertificationTermsApiError'
import CertificationsTermsEditForm from './CertificationsTermsEditForm.vue'

export default {
  components: {
    BCard,
    BSpinner,
    CertificationsTermsEditForm,
  },
  data() {
    return {
      certificationData: null,
      sendInformationEmail: false,
      loading: false,
    }
  },
  beforeMount() {
    store.dispatch('certification/fetchCertification', { id: this.$router.currentRoute.params.id })
      .then(response => {
        if (response && response.status === 200) {
          this.certificationData = mapCertificationApiToFormData(response.data)
        } else {
          // this.$root.$emit('global:error', 'Nie znaleziono terminu certyfikacji.')
          this.$router.replace('/certifications-terms/list')
        }
      })
  },
  methods: {
    submit() {
      const payload = buildCertificationPayload(this.certificationData, this.sendInformationEmail)
      this.loading = true
      store.dispatch('certification/editCertification', {
        id: this.certificationData.id,
        payload,
      })
        .then(response => {
          if (response && response.status === 200) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Zapisano zmiany terminu certyfikacji',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.push({
              name: 'certifications-detail',
              params: { id: this.certificationData.id },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Nie udało się zapisać zmian.',
                icon: 'AlertCircleIcon',
                variant: 'danger',
                text: resolveCertificationTermsApiError(response?.data?.['hydra:description']),
              },
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
